(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlay-product-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('.mlay-shop__form');
    const submit = form.querySelector('button[type="submit"]');
    const quantity = form.querySelector('[name="quantity"]');
    const device = form.querySelector('[data-device-id]');
    const lenses = Array.from(form.querySelectorAll('[data-lens]'));
    const currency = root.dataset.currency;
    const money = value => '\u2066' + new Intl.NumberFormat('en-US', {maximumFractionDigits:3, useGrouping:false}).format(value / 100) + '\u2069 ' + (currency === 'OMR' ? 'ر.ع' : currency);
    const count = () => Math.max(1, Math.floor(Number(quantity.value) || 1));
    const total = () => { root.querySelector('[data-total]').textContent = money((Number(root.dataset.price) + lenses.filter(el => el.checked && !el.disabled).reduce((sum, el) => sum + Number(el.dataset.price), 0)) * count()); };
    root.addEventListener('click', event => {
      const color = event.target.closest('[data-color]');
      if (color && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        root.querySelectorAll('[data-color]').forEach(el => el.setAttribute('aria-current', String(el === color)));
        root.querySelectorAll('[data-gallery]').forEach(el => { el.hidden = el.dataset.gallery !== color.dataset.color; });
        root.querySelector('[data-color-name]').textContent = color.dataset.label;
        root.dataset.price = color.dataset.price;
        device.value = color.dataset.variant;
        const price = Number(color.dataset.price), compare = Number(color.dataset.compare);
        root.querySelector('[data-current-price]').textContent = money(price);
        const compareEl = root.querySelector('[data-compare-price]');
        compareEl.hidden = compare <= price; compareEl.textContent = money(compare);
        const saving = root.querySelector('[data-saving]');
        saving.hidden = compare <= price;
        if (compare > price) saving.textContent = 'وفّري ' + money(compare - price) + ' · خصم ' + '\u2066' + Math.round((compare - price) / compare * 100) + '%\u2069';
        submit.disabled = color.dataset.available !== 'true';
        submit.textContent = submit.disabled ? root.dataset.soldLabel : root.dataset.addLabel;
        root.querySelector('[data-error]').hidden = true;
        total();
      }
      const thumb = event.target.closest('[data-image]');
      if (thumb) {
        const gallery = thumb.closest('[data-gallery]');
        const hero = gallery.querySelector('.mlay-shop__hero');
        hero.removeAttribute('srcset'); hero.src = thumb.dataset.image;
        gallery.querySelectorAll('[data-image]').forEach(el => el.setAttribute('aria-pressed', String(el === thumb)));
      }
    });
    lenses.forEach(el => el.addEventListener('change', total));
    quantity.addEventListener('input', total);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submit.disabled || !form.reportValidity()) return;
      submit.disabled = true; submit.textContent = root.dataset.addingLabel;
      const errorEl = root.querySelector('[data-error]'); errorEl.hidden = true;
      const items = [{id:device.value, quantity:count()}, ...lenses.filter(el => el.checked && !el.disabled).map(el => ({id:el.value, quantity:count()}))];
      try {
        const response = await fetch(form.action + '.js', {method:'POST', headers:{'Content-Type':'application/json', 'Accept':'application/json'}, body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || root.dataset.errorLabel);
        window.location.assign(root.dataset.cart);
      } catch (error) {
        errorEl.textContent = error.message || root.dataset.errorLabel; errorEl.hidden = false;
        submit.disabled = false; submit.textContent = root.dataset.addLabel;
      }
    });
  }
  document.querySelectorAll('[data-mlay-shop]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mlay-shop]').forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mlay-women-day"] && !Shopify.designMode) return;
  try {
    
(() => {
  const counter = document.querySelector('[data-ow-campaign-stock]');
  if (!counter) return;
  let pending = false;
  const refresh = async () => {
    if (document.hidden || pending || !counter.isConnected) return;
    pending = true;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sections', counter.dataset.owSection);
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const sections = await response.json();
      const html = sections[counter.dataset.owSection];
      if (typeof html !== 'string') return;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-ow-campaign-stock]');
      if (next && next.innerHTML !== counter.innerHTML) counter.innerHTML = next.innerHTML;
    } catch (error) {
    } finally {
      pending = false;
    }
  };
  window.setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
})();

  } catch(e) { console.error(e); }
})();
})();
